import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import Table from "../../../../common/components/table";
import PageLoader from "../../../../components/PageLoader";
import { selectnexusARecordsListItems } from "../../../../redux/nexus-a-records/selector";
import { nexusARecords } from "../../../../redux/nexus-a-records/action";
import { nexusARecordTypes } from "../../../../redux/nexus-a-record-types/action";
import { selectnexusARecordTypesListItems } from "../../../../redux/nexus-a-record-types/selector";
import { selectListItems } from "../../../../redux/library/selector";
import _ from "lodash";

const ManagementnexusARecords = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectnexusARecordsListItems)
  const nexusARecordTypeListItems = useSelector(selectnexusARecordTypesListItems)
  const libraryData = useSelector(selectListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.NexusARecordTypeId', headerName: 'Nexus A Record Type', valueFormatter: getRecordTypeName },
      { field: 'Message.HostingURL', headerName: 'HostingURL' },
      { field: 'Message.EntityName', headerName: 'Entity Type', },
      { field: 'Message.ResourceLocationId', headerName: 'Resource Location' },
      { field: 'Message.FQDNName', headerName: 'FQDN Name' },
      { field: 'Message.FQDNHostingProvider', headerName: 'FQDN Hosting Provider' },
      { field: 'Message.BindingDetails', headerName: 'Binding Details' },
      { field: 'Message.DisplayOrder', headerName: 'Display Order' },
    ]);
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }

  const handleDelete = (data: any) => {
    dispatch(nexusARecords.delete({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-records/delete`,
      entity: 'nexusARecords',
      jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              Id: data?.Message?.Id
            }
          }
        ]
      }
    })).then(() => {
      dispatch(nexusARecords.list({
        url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-records/list`,
        entity: 'nexusARecords',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }));
    });
  }

  const additionButtons: any = [
    {
      name: 'Add NexusARecords',
      callback: () => handleAdd(),
    }
  ];

  const fetchNexusARecordsList = () => {
    dispatch(nexusARecords.list({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-records/list`,
      entity: 'nexusARecords',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchNexusARecordsList()
    fetchNexusARecordTypesList()
  }, [pageData, pageSize])

  const fetchNexusARecordTypesList = () => {
    dispatch(nexusARecordTypes.list({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-record-types/list`,
      entity: 'NexusARecordTypes',
      jsonData: {}
    }))
  }

  const getEntityTypeName = (entityTypeId: any) => {
    const item = _.find(libraryData?.result?.EntityTypes, function (o) { return o?.Value === entityTypeId; });
    return item?.Text
  }


  const getRecordTypeName = (recordNameId: any) => {
    const item = _.find(nexusARecordTypeListItems?.result?.items, function (o) { return o.Message?.Id === recordNameId; });
    return item?.Message?.Name
  }

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
          paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete}
          additionButtons={additionButtons} headingName="Nexus-A-Records" />
      }
    </>
  );
};

export default ManagementnexusARecords;




